import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { stats, configure, searchBox } from 'instantsearch.js/es/widgets/index.js';
import { connectRefinementList, connectSortBy, connectStats, connectInfiniteHits } from 'instantsearch.js/es/connectors/index.js';

export function loadAlgolia() {
    const $products = document.getElementById('products');

    // Translations
    const btnCloseFilter = document.getElementById('btn-close-filter');
    const btnSetFilter = document.getElementById('btn-set-filter');
    const btnAddToCart = document.getElementById('btn-add-to-cart');
    const placeholderSearch = document.getElementById('placeholder-aroma-search');
    const placeholderNew = document.getElementById('placeholder-new');
    const labelStockStatus = document.getElementById('label-stock-status');
    const labelAlternatives = document.getElementById('label-alternatives');

    if (!$products) {
        return;
    }

    // When the visitor is logged in (dh_logged_in cookie set by the plugin),
    // read customer-specific stock from Algolia; otherwise use public stock.
    const isLoggedIn = /(?:^|;\s*)dh_logged_in=1/.test(document.cookie);
    console.log(isLoggedIn);

    const activeCategory =  $products.getAttribute('data-categories');
    const algoliaAppId =  $products.getAttribute('data-app-id');
    const algoliaSearchKey =  $products.getAttribute('data-search');
    const algoliaIndex =  $products.getAttribute('data-index');
    const store =  $products.getAttribute('data-store');
    const algoliaShowNicotin =  $products.getAttribute('data-show-nicotin');
    const algoliaHideReview =  $products.getAttribute('data-hide-review');
    const guestSoldOut = $products.getAttribute('data-guest-sold-out');
    // Product IDs that have a "Produkt-Alternativen" content section attached.
    const algoliaAlternativeIds = new Set(
        ($products.getAttribute('data-alternatives') || '').split(',').filter(Boolean)
    );
    const currentLocale = getCurrentLocale();

    const urlParams = new URLSearchParams(window.location.search);
    const presetQuery = urlParams.get("s") || "";
    const activeIndex = urlParams.get("sortby") || algoliaIndex;

    window.addToCart = function(itemId, itemName) {
        const input_quantity = document.getElementById(`quantity_${itemId}`);
        const add_to_cart_button = document.getElementById(`btn-add-${itemId}`);
        add_to_cart_button.setAttribute('data-quantity', input_quantity.value);
    };

    window.addToCartM = function(itemId, itemName) {
        const input_quantity = document.getElementById(`quantity_m_${itemId}`);
        const add_to_cart_button = document.getElementById(`btn-add-m-${itemId}`);
        add_to_cart_button.setAttribute('data-quantity', input_quantity.value);
    };

    window.adjustQuantity = function(inputId, itemId, countItem) {
        const input_quantity = document.getElementById(`${inputId}${itemId}`);
        let quantity = parseInt(input_quantity.value);

        if (countItem == 0) {
            if (quantity > input_quantity.max) {
                input_quantity.value = input_quantity.max;
            } else if (quantity > input_quantity.min) {
                input_quantity.value = input_quantity.min;
            }
        }

        quantity += parseInt(countItem);
        if (quantity < input_quantity.min) {
            return;
        }

        if (quantity > input_quantity.max) {
            return;
        }
        input_quantity.value = quantity
    };


    // Initialize Algolia Search Client
    const searchClient = algoliasearch(
        algoliaAppId,
        algoliaSearchKey
    );

    // Initialize Algolia InstantSearch
    const search = instantsearch({
        indexName: activeIndex,
        searchClient,
        routing: false,
        initialUiState: {
            [activeIndex]: {
                query: presetQuery,
            },
        },
    });

    search.addWidgets([
        configure({
            getRankingInfo: true,
        }),
    ]);

    // Helpers
    function getCurrentLocale() {
        const path = window.location.pathname;
        const pathParts = path.split('/').filter(Boolean);

        // Check for locale in URL path (e.g., /en/, /de/)
        if (pathParts.length > 0) {
            const firstPart = pathParts[0];
            if (firstPart === 'it' || firstPart === 'en' || firstPart === 'fr') {
                return firstPart;
            }
        }

        // Default locale
        return 'de';
    }

    function calculateDiscountPercentage(regularPrice, salePrice) {
        const reg = parseFloat(regularPrice);
        const sale = parseFloat(salePrice);

        if (isNaN(reg) || isNaN(sale) || reg <= 0 || sale >= reg) {
            return 0; 
        }

        const discount = ((reg - sale) / reg) * 100;

        return Math.round(discount);
    }

    // Stats
    const customStats = connectStats((renderOptions, isFirstRender) => {
        const { nbHits, hitsPerPage, page, widgetParams } = renderOptions;
        const container = widgetParams.container;
        const progressCounter = document.getElementById('product-progress-counter');
        const showing = Math.min((page + 1) * hitsPerPage, nbHits);

        if (nbHits && progressCounter) {
            progressCounter.max = parseInt(nbHits);
            progressCounter.value = parseInt(showing);
        }

        container.textContent = `${showing} von ${nbHits} Produkten`;
    });
    
    // Sort
    function createSortByRadios({ container, items }) {
        return connectSortBy((renderOptions, isFirstRender) => {
            const { currentRefinement, options, refine, widgetParams } = renderOptions;
            const root = widgetParams.container;

            if (isFirstRender) {
                root.innerHTML = `
                    <fieldset class="space-y-2">
                        <div id="sortby-radio-wrap" class="tw:flex tw:flex-col tw:gap-2"></div>
                    </fieldset>
                `;

                root.addEventListener('change', (e) => {
                    if (e.target && e.target.name === 'sortby') {
            
                        refine(e.target.value);
                        smoothScrollToTop();
                    }
                });
            }

            // render radios each time
            const wrap = root.querySelector('#sortby-radio-wrap');
            wrap.innerHTML = options.map(opt => `
                <label class="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:text-16px tw:font-light tw:hover:text-primary">
                    <input type="radio" class="hide-sort"
                        name="sortby"
                        value="${opt.value}"
                        ${opt.value === currentRefinement ? 'checked' : ''} />
                    <span>${opt.label} ${opt.value === currentRefinement ? '<i class="fa-solid tw:text-primary tw:ml-2 fa-check"></i>' : ''}</span>
                </label>
            `).join('');
        })({
            container: document.querySelector(container),
            items, 
        });
    }

    // Filter
    function createRefinementWidget({ attribute, listId, buttonId, searchable, attrId}) {
        return connectRefinementList((renderOptions, isFirstRender) => {
            const { items, refine, canRefine, widgetParams, searchForItems } = renderOptions;
            const container = widgetParams.container;

            const filterText = document.getElementById(`${attrId}-text`).getAttribute('data-text');
       
            // Hide the entire widget if there’s nothing to refine
            const filterContainer = document.getElementById(`${attrId}-container`);
            if (canRefine == false) {
                if (filterContainer) {
                    filterContainer.style.display = 'none';
                }
            } else {
                filterContainer.style.display = 'block';
            }
            
            const $containerId = `container-${listId}`;
            const $searchbar = document.getElementById($containerId);
            
            if (isFirstRender) {
                // Search input
                if (searchable && !$searchbar) {
                    const searchContainer = document.createElement('div');
                    searchContainer.id = $containerId;
                    searchContainer.className = 'tw:mt-2 tw:mb-8 tw:grid tw:grid-cols-1';

                    const searchSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    searchSvg.setAttribute('class', 'tw:pointer-events-none tw:size-4 tw:col-start-1 tw:row-start-1 tw:ml-6 tw:self-center');
                    searchSvg.setAttribute('viewBox', '0 0 512 512');
                    searchSvg.innerHTML = '<path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>'

                    const searchInput = document.createElement('input');
                    searchInput.type = 'search';
                    searchInput.placeholder = `${placeholderSearch.innerText}`;
                    searchInput.className = 'tw:col-start-1 tw:row-start-1 tw:block tw:w-full tw:border algolia-filter-search tw:rounded-theme';
                    searchInput.id = `search-input-${listId}`;
                    searchInput.setAttribute('data-auto-focus', '');
              
                    searchContainer.appendChild(searchInput);
                    searchContainer.appendChild(searchSvg);
                    container.appendChild(searchContainer);

                    // Search input binding
                    searchInput.addEventListener('input', (event) => {
                        searchForItems(event.target.value);
                    });
                } else {
                    if (searchable) {
                        const searchInputId = `search-input-${listId}`;
                        const searchInput = document.getElementById(searchInputId);

                        // Search input binding
                        searchInput.addEventListener('input', (event) => {
                            searchForItems(event.target.value);
                        });
                    }
                }

                // List container
                const list = document.createElement('ul');
                list.id = `facet-list-${listId}`;
                list.className = 'ais-RefinementList-list';
                container.appendChild(list);
            
                // Reset button logic
                const resetButton = document.getElementById(buttonId);
                resetButton.addEventListener('click', () => {
                    items.filter(item => item.isRefined).forEach(item => refine(item.value));
                });
            }
            
            const noSearchResults = searchable && items.length === 0;

            // Update only the list on every render
            const list = container.querySelector(`#facet-list-${listId}`);
            list.innerHTML = items.map(item => `
                <li class="ais-RefinementList-item ais-RefinementList-item${item.isRefined ? ' ais-RefinementList-item--selected' : ''}">
                    <div>
                        <label class="ais-RefinementList-label tw:flex tw:text-16px tw:hover:text-primary">
                            <input class="ais-RefinementList-checkbox ais-RefinementList-checkbox" type="checkbox" value="${item.value}" ${item.isRefined ? 'checked' : ''}/>
                            <span class="ais-RefinementList-labelText ais-RefinementList-labelText tw:flex-1">${item.label}</span>
                            <span class="ais-RefinementList-count ais-RefinementList-count">${item.count}</span>
                        </label>
                    </div>
                </li>
            `).join('');

            
            if (noSearchResults) {
                const noResultsText = document.querySelector(`#refinement-no-result-${attrId}`); 
                list.innerHTML = `${noResultsText.innerText}`;
            }


            // Bind checkbox change events
            [...list.querySelectorAll('input[type="checkbox"]')].forEach(input => {
                input.addEventListener('change', (e) => {
                    refine(e.target.value);
                    smoothScrollToTop();
                });
            });

            const selectedCount = items.filter(item => item.isRefined).length;
            const selectedChevron = document.getElementById(`${attrId}-chevron`);
            const removeFilter = document.getElementById(`${attrId}-remove`);
            const closeButton = document.getElementById(`close-${attrId}`);
           
            if (parseInt(selectedCount) > 0) {
                selectedChevron.style.display = 'none';
                removeFilter.style.display = 'block';
          
                document.getElementById(`${attrId}-container`).className = 'selected-items';
                
                const totalSelectedCount = items
                    .filter(item => item.isRefined)
                    .reduce((sum, item) => sum + item.count, 0);

                const selectedLabels = items
                    .filter(item => item.isRefined)
                    .map(item => item.label);

                const filterBtn = document.getElementById(`${attrId}-text`)
                filterBtn.innerHTML =  `${selectedLabels.join(', ')}`;
                
                closeButton.className = 'tw:bg-primary-dark algolia-filter-button tw:font-bold tw:text-white tw:rounded-none tw:w-full tw:h-16 tw:m-0';
                closeButton.innerHTML = `${totalSelectedCount} ${btnSetFilter.innerText}`;

            } else {
                // counter.style.display = 'none';
                selectedChevron.style.display = 'block';
                removeFilter.style.display = 'none';

                const filterBtn = document.getElementById(`${attrId}-text`)
                filterBtn.innerHTML = filterText;
                document.getElementById(`${attrId}-container`).className = '';
                
                closeButton.innerHTML = `${btnCloseFilter.innerText}`;
                closeButton.className = 'tw:hover:bg-gray-lines tw:bg-notice-neutral-bg algolia-filter-button tw:font-bold tw:w-full tw:h-16 tw:m-0 tw:rounded-theme';
            }

            // Toggle visibility of reset button
            const resetButton = document.getElementById(buttonId);
            const hasRefinements = items.some(item => item.isRefined);
            resetButton.style.display = hasRefinements ? 'inline-block' : 'none';
        })({
            container: document.getElementById(listId),
            attribute,
            limit: 1000,
            sortBy: ['name:asc'],
            searchable,
        });
    }

     // Custom InfiniteHits with show more button
    let lastRenderArgs;
    const customInfiniteHits =  connectInfiniteHits(
        (renderOptions, isFirstRender, renderArgs) => {
            const { hits, showMore, isLastPage, widgetParams } = renderOptions;

            lastRenderArgs = renderArgs;
            const btnShowMore = document.getElementById('btn-show-more');

            if (isFirstRender) {
                if (btnShowMore) btnShowMore.addEventListener('click', () => showMore());
            }
         
            const hitsHTML = hits
                .map(hit => widgetParams.templates.item(hit))
                .join('');

            const hitsContainer = document.getElementById('hits');
            if (hitsContainer) hitsContainer.innerHTML = hitsHTML;

            // Toggle state load button
      
            if (btnShowMore) {
                btnShowMore.disabled = isLastPage;
                btnShowMore.textContent = isLastPage ? 'Keine weiteren Produkte' : 'weitere Produkte anzeigen';
            }
        }
    );


    // Add the SearchBox widget
    search.addWidgets([
        configure({
            getRankingInfo: true,
            optionalFilters: [`special_boost:${activeCategory}`],
            filters: activeCategory 
                ? `(taxonomies_de.product_cat:"${activeCategory}") AND (visibility:"visible" OR visibility:"catalog")`
                : `(visibility:"visible" OR visibility:"catalog")`,
        }),
        customInfiniteHits({
            container: document.getElementById('hits'),
            templates: {
                item(hit) {
                    return `
                        <div class="tw:group tw:w-full product-card" itemprop="itemListElement" itemscope itemtype="https://schema.org/Product">
                        <div class="box-image product-small product">
                            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand" class="tw:hidden" aria-hidden="true"><span itemprop="name">${hit.display_hersteller}</span></div>
                            <a href="${hit.display_permalink}" title="${hit.display_title}" class="ais-InfiniteHits-item">
                                <img class="tw:desktop:rounded-theme" itemprop="image" src="${hit.thumbnail_url}" title="${hit.display_title}" alt="${hit.display_title}" onerror="this.onerror=null;this.src='https://placehold.co/200x200/cccccc/333333?text=No+Image';">
                            </a>

                            ${(hit.sale_price || hit.is_new || algoliaShowNicotin) && store == 'shisha-heaven' ? `
                            <div class="tw:absolute tw:left-4 tw:top-4 tw:grid tw:min-w-16 tw:gap-4">
                                
                                ${hit.sale_price ? `
                                    <div class="dh_tag-discount">
                                        <span>-${hit.discount}%</span>
                                    </div>
                                ` : ''}
                                ${hit.is_new ? `
                                    <div class="dh_tag-new">
                                        <span class="tw:font-bold">${placeholderNew.innerText}</span>
                                    </div>
                                ` : ''}

                                ${algoliaShowNicotin && hit.display_nicotin ? `
                                     <div class="dh_tag-nicotin">
                                        <span class="tw:font-bold">${hit.display_nicotin}</span>
                                    </div>
                                `: ''}

                            </div>
                            ` : ''}

                            ${(hit.sale_price || hit.is_new || algoliaShowNicotin) && store == 'vape-schweiz' ? `
                                <div class="tw:absolute tw:right-0 tw:top-16 tw:grid tw:min-w-16 tw:gap-4">
                                    ${hit.sale_price ? `
                                        <div class="label-shadow">
                                            <div class="dh_tag-discount">
                                                <span class="tw:text-[36px]">–${hit.discount}%</span>
                                            </div>
                                        </div>
                                    ` : ''}
                                </div>
                                <div class="tw:absolute tw:left-0 tw:top-6 tw:flex tw:flex-col tw:gap-2">
                                    ${hit.is_new ? `
                                        <div class="label-shadow">
                                            <div class="dh_tag-new">
                                                <span class="tw:font-bold">${placeholderNew.innerText}</span>
                                            </div>
                                        </div>
                                    ` : ''}

                                    ${algoliaShowNicotin && hit.display_nicotin ? `
                                        <div class="label-shadow">
                                            <div class="dh_tag-nicotin">
                                                <span class="tw:font-bold">${hit.display_nicotin}</span>
                                            </div>
                                        </div>
                                    `: ''}
                                </div>
                            ` : ''}

                            

                            ${hit.display_is_in_stock ? `
                                ${!hit.is_bundle ? `
                                    <div class="image-tools hover-fade bottom tw:hidden tw:desktop:group-hover:block tw:w-full tw:bg-white/75 add-to-cart-desktop">
                                        <div class="tw:flex tw:gap-4 add-to-cart-and-quantity_no_category tw:border-hidden tw:px-2 tw:py-4">
                                        <div class="algolia-quantity tw:bg-white tw:rounded-md">
                                            <button type="button" onclick="adjustQuantity('quantity_','${hit.objectID}', -1)" value="-" class="algolia-quantitiy__button algolia-quantitiy__button--minus button minus is-form tw:h-16"><i class="fa-solid fa-minus"></i></button>
                                            <label class="screen-reader-text" for="quantity_${hit.objectID}"></label>
                                            <input type="number" onchange="adjustQuantity('quantity_','${hit.objectID}', 0)" id="quantity_${hit.objectID}" class="algolia-quantity__input tw:h-16 quantity-input-product-${hit.objectID}" name="quantity" value="1" aria-label="Produktmenge" size="4" min="1" max="${hit.stock_quantity < 50 ? hit.stock_quantity : 50 }" step="1" inputmode="numeric" autocomplete="off" />
                                            <button type="button" onclick="adjustQuantity('quantity_','${hit.objectID}', 1)" value="+" class="algolia-quantitiy__button algolia-quantitiy__button--plus button plus is-form tw:h-16 tw:bg-white"><i class="fa-solid fa-plus"></i></button>
                                        </div>

                                        <button type="button" id="btn-add-${hit.objectID}" onclick="addToCart('${hit.objectID}', '${hit.objectID}')" class="primary tw:m-0 tw:w-full button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart is-flat tw:font-bold tw:flex tw:items-center tw:h-16 tw:justify-center tw:px-4 added" data-product_id="${hit.objectID}" data-product_sku="${hit.sku}" rel="nofollow">${btnAddToCart.innerText}</button>
                                        <a href="/warenkorb/" class="added_to_cart wc-forward" title="Warenkorb anzeigen">Warenkorb anzeigen</a>
                                        </div>
                                    </div>
                                ` : `
                                
                                `}
                                ` : `
                                
                                    
                                    <div class="tw:absolute tw:top-[40%] tw:inset-x-0">
                                        <div class="tw:bg-gray-100/90 tw:py-6 tw:px-4 tw:text-stone-800 tw:text-center">
                                            <div class="tw:flex tw:justify-center tw:gap-2 tw:items-center tw:uppercase">
                                            ${hit.sort_lagertyp == 20 ? `
                                                <svg class="tw:h-4 tw:w-4 tw:overflow-visible" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="50%" cy="50%" r="50%" fill="#ff1616"></circle>
                                                </svg>
                                                <span class="tw:font-bold tw:ml-2">${hit.display_lager}</span>
                                            ` : `
                                            ${hit.sort_lagertyp == 10 ? `

                                                <svg class="tw:h-4 tw:w-4 tw:overflow-visible" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="50%" cy="50%" r="50%" fill="#FFB500"></circle>
                                                </svg>
                                                <span class="tw:font-bold tw:ml-2">${hit.display_lager}</span>
                                            ` : `
                                            ${hit.sort_lagertyp == 5 ? `
                                                <svg class="tw:h-4 tw:w-4 tw:overflow-visible" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="50%" cy="50%" r="50%" fill="#FF6600"></circle>
                                                </svg>
                                                <span class="tw:font-bold tw:ml-2">${hit.display_lager}</span>
                                            ` : `<svg class="tw:h-4 tw:w-4 tw:overflow-visible" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="50%" cy="50%" r="50%" fill="#FFB500"></circle>
                                                </svg>
                                                <span class="tw:font-bold tw:ml-2">${hit.display_lager}</span>
                                                `}
                                            `}
                                            `}
                                            </div>
                                            ${algoliaAlternativeIds.has(String(hit.objectID)) ? `
                                                <a href="${hit.display_permalink}" class="button primary is-flat wp-element-button tw:mt-4 tw:mb-0 tw:mx-auto tw:font-bold tw:h-12 tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:px-6 tw:rounded-theme">
                                                    <span>${labelAlternatives ? labelAlternatives.innerText : 'Alternativen entdecken'}</span>
                                                    <svg class="tw:w-4 tw:h-4 tw:fill-white tw:shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true">
                                                        <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"></path>
                                                    </svg>
                                                </a>
                                            ` : ''}
                                        </div>
                                    </div>
                            ` } 
                        </div>

                        <div class="tw:pt-8 tw:px-4 tw:md:px-0">
                            <p class="name product-title woocommerce-loop-product__title">
                                <a href="${hit.display_permalink}" itemprop="url" class="tw:font-bold tw:text-black tw:hover:text-primary">
                                    <span itemprop="name">${hit.display_title}</span>
                                </a>
                            </p>
                            <p class="box-excerpt is-small tw:text-14px tw:text-muted tw:pt-2" itemprop="description">${hit.display_content}</p>

                            <div class="tw:flex tw:items-center tw:justify-between tw:mt-8 tw:gap-2.5 dh_product-on-sale" itemprop="offers" itemscope itemtype="https://schema.org/Offer">
                                <div>
                                    ${hit.sort_lagertyp == 20 ? `
                                        <link itemprop="availability" href="https://schema.org/Discontinued" />  
                                        ` : `
                                    ${hit.sort_lagertyp == 10 ? `
                
                                        <link itemprop="availability" href="https://schema.org/OutOfStock" />  
                                    ` : `<link itemprop="availability" href="https://schema.org/InStock" />`}
                                    `}
                                    <div class="tw:flex tw:items-center tw:gap-1">
                                        ${hit.sale_price ? `
                                    
                                            <span class="tw:text-primary tw:font-bold" itemprop="priceCurrency" content="CHF">CHF</span>
                                            <span class="product-price tw:text-primary tw:font-bold tw:mr-1" content="${hit.sale_price}" itemprop="price"> ${hit.sale_price}</span>
                                            <span class="product-price tw:line-through tw:text-14px">CHF ${hit.regular_price}</span>
                                
                                        ` : `
                                        ${hit.price ? `
                                            <span class="tw:text-black tw:font-bold" itemprop="priceCurrency" content="CHF">CHF</span>
                                            <span class="product-price tw:text-black tw:font-bold" itemprop="price" content="${hit.price}">${hit.price}</span>
                                        ` : 'N/A'}
                                        `}
                                    </div>
                                </div>
                                ${algoliaHideReview ? `` : `
                                    <div class="tw:text-14px">
                                        <etrusted-widget data-etrusted-widget-id="wdg-50aae6f8-4b8d-4447-ae4c-7e57adac5573" data-sku="${hit.sku}"></etrusted-widget>
                                    </div>
                                `}
                                
                            </div>
                            ${hit.display_is_in_stock && !hit.is_bundle ? `
                            <div class="tw:w-full tw:bg-white/75 tw:desktop:hidden add-to-cart-mobile">
                                <div class="tw:flex tw:gap-4 tw:flex-wrap add-to-cart-and-quantity tw:w-screen tw:justify-end tw:-ml-3.75 tw:px-3.75 tw:pt-6 tw:sm:w-auto tw:sm:pb-2 tw:sm:border-hidden">
                                    <div class="algolia-quantity tw:bg-white tw:rounded-md tw:m-0">
                                        <button type="button" onclick="adjustQuantity('quantity_m_','${hit.objectID}', -1)" class="algolia-quantitiy__button algolia-quantitiy__button--minus button minus is-form tw:h-16"><i class="fa-solid fa-minus"></i></button>
                                        <label class="screen-reader-text" for="quantity_m_${hit.objectID}"></label>
                                        <input type="number" id="quantity_m_${hit.objectID}" class="algolia-quantity__input tw:h-16 quantity-input-product-${hit.objectID}" name="quantity" value="1" aria-label="Produktmenge" size="4" min="1" max="50" step="1" inputmode="numeric" autocomplete="off">
                                        <button type="button" onclick="adjustQuantity('quantity_m_','${hit.objectID}', 1)" class="algolia-quantitiy__button algolia-quantitiy__button--plus button plus is-form tw:h-16 tw:bg-white"><i class="fa-solid fa-plus"></i></button>
                                    </div>
                                    <button type="button" id="btn-add-m-${hit.objectID}" onclick="addToCartM('${hit.objectID}', '${hit.objectID}')" class="primary button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart is-flat tw:font-bold tw:flex tw:items-center tw:h-16 tw:m-0 tw:grow tw:justify-center tw:p-0" data-product_id="${hit.objectID}" data-product_sku="${hit.sku}" rel="nofollow">
                                        <span class="tw:sm:hidden!">${btnAddToCart.innerText}</span>
                                        <svg class="svg-inline--fa fa-cart-plus tw:hidden! tw:sm:block!" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="cart-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"></path></svg>
                                    </button>
                                </div>` : `` }
                            </div>
                        </div>
                        </div>
                    `;
                },
            },
            transformItems(items) {
            
            // tiny helpers scoped to this transform
            const isPromoted = (hit) =>
                (hit._rankingInfo && hit._rankingInfo.promoted === true) ||
                hit.promoted === true ||
                hit.isPromoted === true;
            const toNumber = (v) => (v === null || v === undefined || v === '' ? NaN : Number(v));
            
             const processed = items.map(item => {
                let isInStockGuest = item.is_in_stock;
                if (guestSoldOut == 1) {
                    isInStockGuest = item.is_in_stock_guest ?? item.is_in_stock;
                }
                item.display_is_in_stock = isLoggedIn ? item.is_in_stock : isInStockGuest;
             
                const permalink = `permalink_${currentLocale}`;
                item.display_permalink = item[permalink] ? item[permalink] : item.permalink_de;

                const titleAttr = `post_title_${currentLocale}`;
                item.display_title = item[titleAttr] ? item[titleAttr] : item.post_title_de || 'No Title';

                if (item.sale_price === '0.00') {
                item.sale_price = null;
                }

                const contentAttr = `post_short_description_${currentLocale}`;
                item.display_content = item[contentAttr]
                ? item[contentAttr]
                : item.post_short_description_de || 'No Description';

                const localeTaxonomies = `taxonomies_${currentLocale}`;

                if (item[localeTaxonomies] && item[localeTaxonomies].pa_aroma) {
                item.display_aroma = item[localeTaxonomies].pa_aroma.join(', ');
                } else {
                item.display_aroma = undefined;
                }

                if (item[localeTaxonomies] && item[localeTaxonomies].pa_lagertyp) {
                item.display_lager = item[localeTaxonomies].pa_lagertyp.join(', ');
                } else {
                item.display_lager = labelStockStatus.innerText;
                }

                if (item[localeTaxonomies] && item[localeTaxonomies].pa_hersteller) {
                item.display_hersteller = item[localeTaxonomies].pa_hersteller.join(', ');
                } else {
                item.display_hersteller = '';
                }

                if (item[localeTaxonomies] && item[localeTaxonomies].pa_nikotingehaltml) {
                item.display_nicotin = item[localeTaxonomies].pa_nikotingehaltml.join(', ');
                } else {
                item.display_nicotin = 0;
                }

                if (item[localeTaxonomies] && item[localeTaxonomies].pa_anzahlzuege) {
                item.display_zuege = item[localeTaxonomies].pa_anzahlzuege.join(', ');
                } else {
                item.display_zuege = undefined;
                }

                const discount = calculateDiscountPercentage(item.regular_price, item.sale_price);
                if (discount) {
                item.discount = discount;
                }

                return item;
            });

            return processed;

            },
            cssClasses: {
                list: 'tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:lg:grid-cols-3 tw:gap-y-16 tw:gap-x-8',
                item: 'tw:bg-white tw:overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-lg flex flex-col',
                loadMore: 'tw:bg-primary tw:hover:bg-primary-dark tw:button tw:w-full tw:h-16 tw:py-0',
            },
        }),

        createRefinementWidget({ attribute: `taxonomies_${currentLocale}.pa_aroma`, listId: 'aroma-list', buttonId: 'reset-aroma', searchable: true, attrId: 'aroma' }),
        createRefinementWidget({ attribute: `taxonomies_${currentLocale}.pa_farbe`, listId: 'color-list', buttonId: 'reset-color', searchable: false, attrId: 'color' }),
        createRefinementWidget({ attribute: `taxonomies_${currentLocale}.pa_nikotingehaltml`, listId: 'nicotin-list', buttonId: 'reset-nicotin', searchable: false, attrId: 'nicotin' }),
        createSortByRadios({
            container: '#sortby-radios',
            items: [
                { value: algoliaIndex, label: 'Standard' },
                { value: `${algoliaIndex}_price_asc`, label: 'Preis aufsteigend' },
                { value: `${algoliaIndex}_price_desc`, label: 'Preis absteigend' },
                { value: `${algoliaIndex}_best_rating`, label: 'Best bewertet zuerst' },
                { value: `${algoliaIndex}_date_desc`, label: 'Neuste zuerst' },
                { value: `${algoliaIndex}_date_asc`, label: 'Älteste zuerst' },
            ],
        }),
        customStats({
            container: document.getElementById('product-all-counter'),
        }),
        stats({
          container: '#product-counter',
            templates: {
                text: data => `${data.nbHits}&nbsp;`
            }
        }),
        searchBox({
            container: '#category-title',
            queryHook(query, search) {
                search(query);
            },
        }),
    ]);

    search.start();

    const smoothScrollToTop = () => {
        document.getElementById('algolia-index').scrollIntoView({
            behavior: 'smooth'
        });
    }
    
    document.getElementById('aroma-remove').addEventListener('click', (e) => {
        e.preventDefault();
        search.helper.clearRefinements(`taxonomies_${currentLocale}.pa_aroma`).search();
        smoothScrollToTop();
    });

    document.getElementById('color-remove').addEventListener('click', (e) => {
        e.preventDefault();
        search.helper.clearRefinements(`taxonomies_${currentLocale}.pa_farbe`).search();
        smoothScrollToTop();
    });

    document.getElementById('nicotin-remove').addEventListener('click', (e) => {
        e.preventDefault();
        search.helper.clearRefinements(`taxonomies_${currentLocale}.pa_nikotingehaltml`).search();
        smoothScrollToTop();
    });

    document.getElementById('close-aroma').addEventListener('click', () => {
       smoothScrollToTop();
    });
    
    document.getElementById('close-color').addEventListener('click', () => {
       smoothScrollToTop();
    });

    document.getElementById('close-nicotin').addEventListener('click', () => {
       smoothScrollToTop();
    });

    document.getElementById('reset-aroma').addEventListener('click', () => {
        search.helper.clearRefinements(`taxonomies_${currentLocale}.pa_aroma`).search();
        smoothScrollToTop();
    });

    document.getElementById('reset-nicotin').addEventListener('click', () => {
        search.helper.clearRefinements(`taxonomies_${currentLocale}.pa_nikotingehaltml`).search();
        smoothScrollToTop();
    });

    document.getElementById('reset-color').addEventListener('click', () => {
        search.helper.clearRefinements(`taxonomies_${currentLocale}.pa_farbe`).search();
        smoothScrollToTop();
    });
}